module.exports = __webpack_public_path__ + "img/overview_d.59cce518.svg";